import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByTeam state domain
 */

const selectWidgetResultByTeamDomain = (state) =>
  state.get("widgetResultByTeam", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingTeams = () =>
  createSelector(selectWidgetResultByTeamDomain, (state) =>
    state.get("isLoadingTeams")
  )

export const makeSelectTeamsDrillDown = () =>
  createSelector(selectWidgetResultByTeamDomain, (state) =>
    state.get("teamsDrillDown")
  )

export const makeSelectDimensions = () =>
  createSelector(selectWidgetResultByTeamDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectMetric = () =>
  createSelector(selectWidgetResultByTeamDomain, (state) => state.get("metric"))

export const makeSelectTeams = () =>
  createSelector(selectWidgetResultByTeamDomain, (state) => state.get("teams"))

/**
 * Default selector used by WidgetResultByTeam
 */

const makeSelectWidgetResultByTeam = () =>
  createSelector(selectWidgetResultByTeamDomain, (substate) => substate.toJS())

export default makeSelectWidgetResultByTeam
export { selectWidgetResultByTeamDomain }
